import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import Master_SubscriptionsView from "../../../master/SubscriptionsView.tsx";

export const Route = createFileRoute('/_app/master/subscriptions')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Master_SubscriptionsView />
}
